import { isNullOrUndefined } from '@standardnotes/utils';
export class ChallengeResponse {
    constructor(challenge, values, artifacts) {
        this.challenge = challenge;
        this.values = values;
        this.artifacts = artifacts;
        Object.freeze(this);
    }
    getValueForType(type) {
        const value = this.values.find((value) => value.prompt.validation === type);
        if (isNullOrUndefined(value)) {
            throw Error('Could not find value for validation type ' + type);
        }
        return value;
    }
    getDefaultValue() {
        if (this.values.length > 1) {
            throw Error('Attempting to retrieve default response value when more than one value exists');
        }
        return this.values[0];
    }
}
